// formata BRL: 2 → "2,00"
export function brl(v) {
  return Number(v).toFixed(2).replace('.', ',');
}

// iniciais: 1ª letra do primeiro nome + 1ª letra do último sobrenome (se houver)
export function initials(firstName = '', lastName = '') {
  const parts = `${firstName} ${lastName}`.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
  return (first + last).toUpperCase();
}

// máscaras de input — compartilhadas entre cadastro e edição de perfil
export const maskCPF = (v) =>
  v.replace(/\D/g, '').slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1-$2');

export const maskPhone = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

export const maskCep = (v) => v.replace(/\D/g, '').slice(0, 8).replace(/(\d{5})(\d)/, '$1-$2');

export const maskExpiry = (v) =>
  v.replace(/\D/g, '').slice(0, 4)
    .replace(/(\d{2})(\d)/, '$1/$2');

// Valida os dígitos verificadores do CPF (não só a quantidade de dígitos) —
// rejeita sequências como 111.111.111-11 que passam num check de length===11.
export function isValidCPF(v) {
  const digits = (v || '').replace(/\D/g, '');
  if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;

  const calcDigit = (base) => {
    let sum = 0;
    for (let i = 0; i < base.length; i++) sum += Number(base[i]) * (base.length + 1 - i);
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  const d1 = calcDigit(digits.slice(0, 9));
  const d2 = calcDigit(digits.slice(0, 10));
  return d1 === Number(digits[9]) && d2 === Number(digits[10]);
}
